import React, { useEffect } from 'react'
import { ITab } from '../../../../Shared/Tabs/types';
import TabNavbarV2 from '../../../../Shared/Tabs/TabNavbarV2';
import { ClinicTab, ClinicTabLabels } from './types';
import { useHistory, useLocation } from 'react-router-dom';

interface ClinicTabsProps {
  currentTab: ClinicTab;
  onChange: (tab: ClinicTab) => void;
}

const ClinicTabs = ({ currentTab, onChange }: ClinicTabsProps) => {
  const history = useHistory();
  const location = useLocation();

  const tabNames = Object.values(ClinicTabLabels).map(label => label.toLowerCase());

  const handleTabChange = (tab: ClinicTab) => {
    const tabName = tabNames[tab];
    history.push(`?tab=${tabName}`);
    onChange(tab);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabName = params.get('tab');
    if (tabName) {
      const tabIndex = tabNames.indexOf(tabName);
      if (tabIndex !== -1) {
        onChange(tabIndex as ClinicTab);
      }
    }
  }, [location.search, onChange, tabNames]);

  const tabs: ITab[] = Object.values(ClinicTabLabels).map(label => ({ label }));

  return <TabNavbarV2 currentTab={currentTab} onChange={handleTabChange} tabs={tabs} />;
};

export default ClinicTabs;
